import React from 'react';
import './PetAnimations.css';

export default function FrogSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#5DAA5D';
  const lightColor = color ? lighten(color) : '#88CC88';
  const darkColor = color ? darken(color) : '#3D8A3D';
  const bellyColor = '#C8E8A0';
  const spotColor = '#3A7A3A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body */}
      <ellipse cx="60" cy="72" rx="30" ry="20" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="76" rx="20" ry="14" fill={bellyColor} />
      {/* Body spots */}
      <circle cx="44" cy="66" r="3" fill={spotColor} opacity="0.5" />
      <circle cx="76" cy="68" r="2.5" fill={spotColor} opacity="0.5" />
      <circle cx="68" cy="62" r="2" fill={spotColor} opacity="0.4" />
      {/* Back legs (folded) */}
      <ellipse cx="36" cy="82" rx="12" ry="7" fill={bodyColor} />
      <ellipse cx="84" cy="82" rx="12" ry="7" fill={bodyColor} />
      {/* Webbed back feet */}
      <path d="M24 86L20 92L26 90L28 96L32 90L36 94L34 86Z" fill={darkColor} />
      <path d="M96 86L100 92L94 90L92 96L88 90L84 94L86 86Z" fill={darkColor} />
      {/* Front legs */}
      <rect x="44" y="84" width="6" height="10" rx="3" fill={bodyColor} />
      <rect x="70" y="84" width="6" height="10" rx="3" fill={bodyColor} />
      {/* Webbed front feet */}
      <path d="M42 94L40 100L46 98L48 102L50 96L52 94Z" fill={darkColor} />
      <path d="M68 94L66 100L72 98L74 102L76 96L78 94Z" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="52" rx="24" ry="16" fill={bodyColor} />
      {/* Eye bumps */}
      <circle cx="44" cy="40" r="10" fill={bodyColor} />
      <circle cx="76" cy="40" r="10" fill={bodyColor} />
      {/* Eyes */}
      <circle cx="44" cy="38" r="7" fill="white" />
      <circle cx="76" cy="38" r="7" fill="white" />
      <circle cx="46" cy="38" r="4" fill="#C88820" />
      <circle cx="78" cy="38" r="4" fill="#C88820" />
      <circle cx="46" cy="38" r="2" fill="#1A1A1A" />
      <circle cx="78" cy="38" r="2" fill="#1A1A1A" />
      <circle cx="47" cy="36.5" r="1.2" fill="white" />
      <circle cx="79" cy="36.5" r="1.2" fill="white" />
      {/* Wide mouth */}
      <path d="M40 56C48 62 72 62 80 56" stroke={darkColor} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      {/* Nostrils */}
      <circle cx="54" cy="50" r="1.5" fill={darkColor} />
      <circle cx="66" cy="50" r="1.5" fill={darkColor} />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
